// extracted by mini-css-extract-plugin
export default {"resourceCard":"resourceCard_resourceCard__oqP23","animatedTitle":"resourceCard_animatedTitle__ZMwp0","slideForward":"resourceCard_slideForward__W8Iz7"};